import React, { useState, useRef, useEffect, useMemo } from "react";
import {
	Modal,
	Form,
	Row,
	Col,
	Overlay,
	Popover,
	Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import Flatpickr from "react-flatpickr";
import "bootstrap/dist/css/bootstrap.min.css";
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchCountry, selectCountry } from "../../redux/actions/countryAction";
import { useDispatch, useSelector } from "react-redux";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { fetchGenders, selectGender } from "../../redux/actions/genderActions";
import axios from "../../API/axios";
import moment from "moment";
import toast from "react-hot-toast";
import {
	fetchInstituteData,
	selectGetInstitute,
} from "../../redux/actions/getInstitutesAction";
import { useParams } from "react-router-dom";
import {
	fetchDesignation,
	selectDesignation,
} from "../../redux/actions/designationAction";
import {
	fetchCompanyData,
	selectGetCompanies,
} from "../../redux/actions/getCompaniesAction";
import { fetchLanguage } from "../../redux/actions/LanguageAction";
import DatePicker from "react-datepicker";
import { fetchOrgRegdInsData } from "../../redux/actions/getRegdInsAction";
import { fetchOrgRegdCompData } from "../../redux/actions/getRegdComAction";

const UpdateResume = ({ show, handleClose, userDataInfo, modalOpen, getUserCv, showActiveAs, handleCloseActiveAs }) => {
	// console.log("userDataInfo1====>", userDataInfo.cnddtId);

	const sessionId = localStorage.getItem("sessionId");
	const userUID = localStorage.getItem("userUID");
	const moduleName = localStorage.getItem("Module");
	const [email, setEmail] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	console.log("userDataInfo=======>", userDataInfo);

	// ...............................language DDL.......................................

	const [language, setLanguage] = useState([]);
	const dispatch = useDispatch();
	const { LanguageList, selectedLanguageId } = useSelector(
		(state) => state.language
	);
	// console.log("language", LanguageList);

	useEffect(() => {
		dispatch(fetchLanguage());
	}, [dispatch]);

	const handleLanguageSelect = (selectedOption) => {
		if (selectedOption) {
			setLanguage(selectedOption.value);
		} else {
			setLanguage(null);
		}

	};
	// ...............................language DDL.......................................

	// ...............................Gender DDL.......................................

	const [genderValue, setGenderValue] = useState("");
	const { genderOptions, selectedGender } = useSelector(
		(state) => state.gender
	);

	useEffect(() => {
		dispatch(fetchGenders());
	}, [dispatch]);
	const handleGenderSelect = (selectedOption) => {
		if (selectedOption) {
			setGenderValue(selectedOption.value);
		} else {
			setGenderValue(null);
		}
	};
	// ...............................Gender DDL.......................................

	// ...............................City DDL.......................................

	const { cityList, selectedcityId } = useSelector((state) => state.cities);
	const [cityId, setcityId] = useState("");
	const [tempCity, setTempCity] = useState(null);
	useEffect(() => {
		dispatch(fetchCityData());
	}, [dispatch]);

	const handleCityInputChange = (inputValue) => {
		dispatch(fetchCityData(inputValue));
	};

	// const handleCityChange = (option) => {
	// 	setTempCity(option); // UI ke liye value change karo
	// 	if (option) 
	// 		setcityId(option.value); // Sirf tab update ho jab user select kare
	// };

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			//   dispatch(selectCity(selectedOption.value));
			setcityId(selectedOption.value);
		} else {
			setcityId(null);
		}
	};

	// const handleModalClose = () => {
	// 	setTempCity({ value: cityId, label: cityList.find(c => c.value === cityId)?.label || profileData.cityName });
	// };
	// ...............................City DDL.......................................

	// ...............................PROFILE Start.......................................
	const [displays, setDisplays] = useState(false);
	const [startDate, setStartDate] = useState("");
	const [profileImage, setProfileImage] = useState(null);
	const [profileImageview, setProfileImageview] = useState("");
	const [error, setError] = useState(null);
	const [about, setAbout] = useState("");
	const [headLine, setHeadLine] = useState("");
	const [website, setWebsite] = useState("");
	const [curretactive, setCurretactive] = useState("");
	const [orgType, setOrgType] = useState(0);
	const { CandidateId } = useParams();
	const [activeStep, setActiveStep] = useState(1);
	const [step, setStep] = useState(1);
	// .......................... Basic Info
	const [formChanged, setFormChanged] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);

	// Function to handle field changes and set formChanged to true
	const handleFieldChange = (setter, value) => {
		setter(value);
		setFormChanged(true);
	};
	// console.log("curretactive", curretactive);

	// ..............................
	// ..............................
	const [formChangedNew, setFormChangedNew] = useState(false);

	// Updated function to handle field changes and set formChangedNew to true
	const handleFieldChangeNew = (setter, value) => {
		// console.log("value ab", value);

		setter(value);
		setFormChangedNew(true);
	};

	const handleSaveClickNew = (e) => {
		if (CandidateId === "Candidate") {
			UpdateProfile(e);
		} else {
			UpdateProfileInstitute(e);
		}
		setFormChangedNew(false); // Reset after saving
	};

	// Reset state when modal opens
	React.useEffect(() => {
		if (modalOpen) {
			setFormChangedNew(false); // Reset the formChanged state
		}
	}, [modalOpen]);

	// ..............................



	const handleProfileImageChange = (event) => {
		const selectedFile = event.target.files[0];
		const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

		if (selectedFile) {
			// Validate file type
			if (!validImageTypes.includes(selectedFile.type)) {
				setError('Only JPEG and PNG images are allowed.');
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// Validate file size (limit to 2MB)
			const maxSizeInMB = 10;
			if (selectedFile.size > maxSizeInMB * 1024 * 1024) {
				setError(`File size should not exceed ${maxSizeInMB}MB.`);
				setProfileImage(null);
				setProfileImageview(null);
				return;
			}

			// If valid, update the state
			setProfileImage(selectedFile);
			setProfileImageview(URL.createObjectURL(selectedFile));
			setError(null);
		}
	};

	const Profile = async (e) => {
		e.preventDefault();
		try {
			setDisplays(true);
			setIsSubmitting(true); // Disable the button during submission
			if (
				genderValue &&
				cityId &&
				startDate &&
				language &&
				profileImage !== ""
			) {
				const formData = new FormData();
				formData.append("LangId", language);
				formData.append("GenderId", genderValue);
				formData.append("CityId", cityId);
				formData.append("Email", email);
				formData.append("FirstName", firstName);
				formData.append("LastName", lastName);
				formData.append("Dob", startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"));
				formData.append("ProfileImage", profileImage);
				formData.append("sessionId", sessionId);
				const res = await axios.post(
					"/Account/UpdateCandidateProfile",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);
				// console.log("get data", res);
				toast.success(res.data.message);
				handleClose();
				getUserCv()
				setDisplays(false);
				setFormChanged(false); // Disable the button after successful update

				localStorage.setItem("genderValue", genderValue);
				localStorage.setItem("cityId", cityId);
				localStorage.setItem("startDate", startDate);
				localStorage.setItem("language", language);
				localStorage.setItem("profileImage", profileImage);

			} else {
				toast.error("Please enter required fields!");
			}
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			}if (error.response && error.response.status === 500) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.title);
			}
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};
	// console.log("curretactive", curretactive);

	const UpdateProfile = async (e) => {
		console.log("details");

		e.preventDefault(); // Prevent default form submission behavior

		if ((orgType === "1" || orgType === 1 || orgType === "4" || orgType === 4) && !instituteId) {
			toast.error("Institute is required.");
			setDisplays(false);
			return;
		}
		if ((orgType !== "1" && orgType !== 1 && orgType !== "4" && orgType !== 4) && !companyId) {
			toast.error("Company is required.");
			setDisplays(false);
			return;
		}
		if ((orgType !== "1" && orgType !== 1 && orgType !== "4" && orgType !== 4) && !designationId) {
			toast.error("Designation Name is required.");
			setDisplays(false);
			return;
		}

		console.log("details");

		try {
			setDisplays(true);

			let body = {
				sessionId: sessionId,
				currentlyActiveAs: curretactive,
				orgType: String(orgType),
			};

			if (orgType === "1" || orgType === 1 || orgType === "4" || orgType === 4) {
				body.insttnId = instituteId;
				body.compId = null;
				body.designationName = null;
				body.headLine = headLine;
				body.about = about;
				body.website = website;
			} else {
				body.insttnId = null;
				body.compId = companyId;
				body.designationName = designationId;
				body.headLine = headLine;
				body.about = about;
				body.website = website;
			}
			console.log("body11", body);
			// API request to update the profile
			const res = await axios.post("/CandidateData/Update", body);

			console.log("Update Response:", res);

			handleCloseActiveAs();
			toast.success(res.data.message);

			setDisplays(false);
			getUserCv()
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
				console.log("error", error);

			} else
				if (error.response.status === "Error") {
					toast.error(error.response?.message);
				}
				else {
					toast.error(error.response?.data?.message);
					// console.log(error);

				}
		}
	};
	// ...............................PROFILE End.......................................
	// ...............................PROFILE Institute Start.......................................

	const InstituteProfile = async (e) => {
		e.preventDefault();
		try {
			setDisplays(true);
			setIsSubmitting(true); // Disable the button during submission

			// Extract language IDs as a comma-separated string
			// const multiLang = language ? language.map((option) => option.value) : [];
			// console.log("multiLang (to be appended):", multiLang);

			if (startDate !== "") {
				const formData = new FormData();
				// formData.append("LangId", multiLang.join(","));  
				formData.append("LangId", language);
				formData.append("InstnCnddtId", CandidateId);
				formData.append("GenderId", genderValue);
				formData.append("FirstName", firstName);
				formData.append("LastName", lastName);
				formData.append("Email", email);
				formData.append("CityId", cityId);
				formData.append("ProfileImage", profileImage);
				formData.append("Dob", startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD"));
				formData.append("SessionId", sessionId);

				// Log FormData for debugging
				for (let pair of formData.entries()) {
					// console.log(pair[0] + ": " + pair[1]);
				}

				const res = await axios.post("/Candidate/UpdateInsttCandidateBasicInfo",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);
				// console.log("Response Data:", res);

				toast.success(res.data.message);
				setDisplays(false);
				setFormChanged(false); // Disable the button after successful update
				handleClose();
				getUserCv();

			} else {
				toast.error("Please enter required fields!");
			}
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.title);
			}
		} finally {
			setIsSubmitting(false); 
		}
	};

	const UpdateProfileInstitute = async (e) => {
		e.preventDefault();
		try {
			if (!curretactive || !orgType) {
				toast.error("Please fill all required fields.");
				return;
			}

			if (orgType === "1" && !instituteId && !headLine && !website && !about) {
				
				toast.error("Please select an Institution.");
				return;
			} else if (orgType !== "2") {
				console.log("enter If else ")
				if ( !companyId && !designationId && !headLine && !website && !about) {
					toast.error("Please fill all required fields.");
					return;
				}
			}

			let body = {
				sessionId: sessionId,
				currentlyActiveAs: curretactive,
				instnCnddtId: CandidateId,
				orgType: String(orgType),
			};
			// console.log("orgType (should be string):", body.orgType);

			if (orgType === "1" || orgType === 1 || orgType === 4 || orgType === "4") {
				body.insttnId = instituteId;
				body.compId = null;
				body.designationName = null;
				body.headLine = headLine || "";
				body.about = about || "";
				body.website = website || "";
			} else {
				if (!designationId?.trim()) {
					toast.error("Designation is required");
					return;
				}
				body.insttnId = null;
				body.compId = companyId;
				body.designationName = designationId;
				body.headLine = headLine || "";
				body.about = about || "";
				body.website = website ||"";
			}
			// console.log("body", body);
			// API request to update the profile
			const res = await axios.post("/Candidate/UpdateInsttCandidateOnlyProfile", body);

			console.log("Update Response:", res);

			// Show success message and reset form fields
			toast.success(res.data.message);
			getUserCv();
			handleCloseActiveAs();
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response?.errors?.model);
				console.log("log ", error.response

				);
			} else {
				toast.error(error.response?.data?.errors?.model);
				console.log("log ", error.response)
			}
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};

	// ...............................PROFILE Institute End.......................................

	// .............................. designation Dropdown ...............................

	const [designationSearch, setDesignationSearch] = useState("");
	const [designationId, setDesignationId] = useState("");
	const { designationList, selectedDesignationId } = useSelector(
		(state) => state.designation
	);
	useEffect(() => {
		dispatch(fetchDesignation());
	}, [dispatch]);
	const handleDesignation = (selectedOption) => {
		if (selectedOption) {
			setDesignationId(selectedOption.label);
		} else {
			setDesignationId(null);
		}
	};
	// ...............................Designation Dropdown.......................................

	// // ...............................Institute Dropdown.......................................
	const [instituteSearch, setInstituteSearch] = useState("");
	const [instituteId, setInstituteId] = useState(null);
	const { getallorgsList, selectedinstituteId } = useSelector(
		(state) => state.getRegdIns
	);
	console.log("List ORG===>", getallorgsList)

    const reversedOrgList = useMemo(() => {
    return [...getallorgsList].reverse(); // Create a new reversed copy
    }, [getallorgsList]);

	useEffect(() => {
		dispatch(fetchOrgRegdInsData());
	}, [dispatch]);

	const handleInstitute = (selectedOption) => {
		console.log("Selected Institution===>", selectedOption)
		if (selectedOption) {
			setInstituteId(selectedOption.value);
			setOrgType(selectedOption.tagId);
		} else {
			setInstituteId(null);
		}
	};
	// // ...............................Institute Dropdown.......................................

	// ...............................Company Dropdown.......................................
	const [companySearch, setCompanySearch] = useState("");
	const [companyId, setCompanyId] = useState(null);
	const { getRegdCompList, selectedcompaniesId } = useSelector(
		(state) => state.getRegdComp
	);
	console.log("company Name List===>", getRegdCompList)

	const reversedCompList = useMemo(() => {
		return [...getRegdCompList].reverse(); // Create a new reversed copy
		}, [getRegdCompList]);

	useEffect(() => {
		dispatch(fetchOrgRegdCompData());
	}, [dispatch]);

	const handleCompany = (selectedOption) => {
		 console.log("Selected Company===>", selectedOption)
		if (selectedOption) {
			setCompanyId(selectedOption.value);
			setOrgType(selectedOption.tagId);
		} else {
			setCompanyId(null);
		}
	};
	// ...............................company Dropdown.......................................

	// ...............................Get PROFILE Start.......................................
	// const [profileData, setProfileData] = useState("");
	// const GetProfile = async () => {
	// 	try {
	// 		const res = await axios.get(`/Candidate/GetBasicProfile?UID=${userUID}`);
	// 		// console.log("eposne", res);

	// 		setProfileData(res.data.responseData);
	// 		const userData = res.data.responseData;
	// 		localStorage.setItem("firstName", userData.firstName);
	// 		localStorage.setItem("lastName", userData.lastName);
	// 		localStorage.setItem("langName", userData.langName);
	// 		localStorage.setItem("cityName", userData.cityName);
	// 		localStorage.setItem("genderName", userData.genderName);
	// 		localStorage.setItem("profilPic", userData.profileImage);
	// 	} catch (error) {
	// 		// console.log("error", error);
	// 	}
	// };
	// useEffect(() => {
	// 	GetProfile();
	// }, []);
	// console.log("profileData", profileData);

	// useEffect(() => {
	// 	if (profileData) {
	// 		setGenderValue(profileData?.genderId);
	// 		dispatch(selectGender(profileData?.genderId));
	// 		setFirstName(profileData?.firstName);
	// 		setLastName(profileData?.lastName);
	// 		setEmail(profileData?.email);
	// 		setLanguage(profileData?.langId);
	// 		// setcityId(profileData?.cityId);
	// 		// dispatch(selectCity(profileData?.cityId));
	// 		// setcityId(profileData.cityId || ""); // Backend wali value safe rakho
	// 		// setTempCity({ value: profileData.cityId, label: profileData.cityName }); // UI ke liye
	// 		setStartDate(profileData?.dob);
	// 		// setProfileImageview(profileData?.profileImage);
	// 		// setProfileImage(profileData?.profileImage)
	// 		dispatch(fetchCityData(profileData?.cityName));
	// 	}
	// }, [profileData]);

	// Assuming userDataInfo?.fullName contains the full name
	const fullName = userDataInfo?.fullName || "";

	// Split the full name into an array of words
	const nameParts = fullName.split(" ");

	// Assign the first part as the first name
	const fName = nameParts[0] || "";

	// Assign the remaining parts as the last name
	const lName = nameParts.slice(1).join(" ") || "";

	const languageId = userDataInfo?.langIDs?.[0]; // Safely access the first element
	console.log("userDataInfo", userDataInfo);


	useEffect(() => {
		if (userDataInfo) {
			setOrgType(userDataInfo?.orgType);
			// setCurretactive(userDataInfo?.currentlyActiveAsName);			
			setDesignationId(userDataInfo?.dsgntnName);
			dispatch(fetchDesignation(userDataInfo?.dsgntnName));

			setDesignationId(userDataInfo?.dsgntnId);
			dispatch(fetchDesignation(userDataInfo?.dsgntnName));

			setCompanyId(userDataInfo?.orgId);
			dispatch(fetchOrgRegdCompData(userDataInfo?.orgTypeName));

			// setInstituteId(userDataInfo?.compId);
			setLanguage(languageId);
			setEmail(userDataInfo?.email);
			setStartDate(userDataInfo?.dob);
			// setProfileImage(userDataInfo?.userImage);
			setProfileImageview(userDataInfo?.userImage);
			setProfileImage(userDataInfo?.userImage);
			setFirstName(fName);
			setLastName(lName);
			setHeadLine(userDataInfo?.headLine);
			setWebsite(userDataInfo?.webSiteLink);
			setAbout(userDataInfo?.about);
			setGenderValue(userDataInfo?.gender);
			setGenderValue(userDataInfo?.genderId);
			setcityId(userDataInfo?.currentCityId);
			dispatch(fetchCityData(userDataInfo?.currentCity));
			// if (moduleName === "Institution") {
			// 	setcityId(userDataInfo?.currentCityId);
			// 	dispatch(fetchCityData(userDataInfo?.currentCity));
			// }

			setInstituteSearch(userDataInfo?.orgName);
			setInstituteId(userDataInfo?.orgId);
			setDesignationId(userDataInfo?.dsgntnName);
			// setOrganizationName(userDataInfo?.compName);
			//setcityId(userDataInfo?.currentCity);
			setCurretactive(
				activeOptions.find(option => option.label === userDataInfo?.currentlyActiveAsName)?.value || ""
			);
		}
	}, [userDataInfo]);

	console.log("userDataInfo?.compName", userDataInfo?.orgName);


	const handleNext = (e) => {
		if (!firstName || !lastName || !email) {
			setDisplays(true); // Show errors
		} else {
			// BasicProfile();
			if (CandidateId === "Candidate") {
				Profile(e);
			} else {
				InstituteProfile(e);
			}
			setDisplays(false); // Hide errors
			setStep(2); // Move to next step
		}
	};

	const handleActive = (selectedOption) => {
		// console.log("selectedOption", selectedOption);

		if (selectedOption) {
			setCurretactive(selectedOption.value);

			if (selectedOption.value === "1") {
				console.log("Selected Option==>if")
				setOrgType("1");
			} else { // If not student
				console.log("Selected Option==>else")
				setOrgType("2");

			}
		} else {
			setCurretactive('');
			setOrgType(''); // Reset orgType if no option is selected
		}
	};

	const activeOptions = [
		{ value: "1", label: "Student" },
		{ value: "2", label: "Professional" },
	];
	const [OrganizationName, setOrganizationName] = useState("");
	const [InsName, setInsName] = useState("");
	const [showTooltip, setShowTooltip] = useState(false);
	const targetRef = useRef(null);
	const toggleTooltip = () => {
		// console.log("Toggling Tooltip");
		setShowTooltip((prev) => !prev);
	};
	const [orgCity, setOrgCity] = useState(null);
	const [cityNameOption, setCityNameOption] = useState([])
	const [searchTerm, setSearchTerm] = useState("")

	const getCityList = async (pageNumber = 1, pageSize = 10) => {
		try {
			const response = await axios.post(`/MasterData/GetCitiesDDL?Search=${searchTerm}&CountryName=India`, {
				pageNumber,
				pageSize
			})
			//   console.log("Get City Name List==>",response)
			const cityList = response.data.responseData.citiesDDL.map((val) => ({
				value: val.id,
				label: val.name,
			}));
			setCityNameOption(cityList)
		}
		catch (error) {
			//toast.error(error.message || 'Something went wrong while fetching city data',)
		}
	}

	useEffect(() => {
		getCityList();
	}, [searchTerm]);

	const handleCitySelectOrg = (selectedOption) => {
		setOrgCity(selectedOption ? selectedOption.value : "")
		// console.log("Selected City:", selectedOption);
		setSearchTerm(""); // Search term clear karein
		setCityNameOption([]); // Dropdown options clear karein
	};
	const handleCitySelect1 = (selectedOption) => {
		if (selectedOption) {
			setOrgCity(selectedOption.value);
		} else {
			setOrgCity(null);

		}
	};
	const [fileName, setFileName] = useState("");
	const handleFileChange = (event) => {
		const file = event.target.files[0]; // Get the selected file
		if (file) {
			setFileName(file.name); // Set the filename in state
		}
	};

	const [getOrgInsTId, setGenOrgInstId] = useState(null);
	const [newOrgType, setnewOrgType] = useState(null);
	const [newOrgType1, setnewOrgType1] = useState(null);
	const [getOrgInsTId1, setGenOrgInstId1] = useState(null);

	//----------------Add New Institution----------------//

	const handleSaveInstitution = async () => {
		// setDisplay(true);

		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdInstitution");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		// console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			const newOrg = {
				value: res.data.responseData.id,  
				label: OrganizationName, 
				tagId: 4,
			};
			dispatch(fetchOrgRegdInsData()); 

			setInstituteId(res.data.responseData.id);
			setInsName(""); 

			// setGenOrgInstId(res.data.responseData.id);
			//setnewOrgType(res.data.responseData.value);
			toast.success(`${res.data.message} The newly created institution is now available at the top of the dropdown. Please select it.`);
			// dispatch(fetchOrgRegdInsData())
			// setInstituteSearch("")
			setOrganizationName("");
			setOrgCity(null);
			setFileName("");
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};

	//----------------Add New Company----------------//

	const handleSaveInstitution1 = async () => {
		// setDisplay(true);

		const formData = new FormData();
		formData.append("orgName", OrganizationName);
		formData.append("OrgType", "UnRegdCompany");
		formData.append("CityID", orgCity);
		formData.append("OrgLogo", fileName);
		formData.append("sessionId", sessionId);
		// console.log("formData", formData);

		try {
			const res = await axios.post("/Feature/AddGnrlOrgData", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			// console.log("res====>", res);

			const newOrg = {
				value: res.data.responseData.id,  
				label: OrganizationName, 
				tagId: 3,
			};
			dispatch(fetchOrgRegdCompData()); 

			setCompanyId(res.data.responseData.id);
			setInsName(""); 
			//setGenOrgInstId1(res.data.responseData.id);
			//setnewOrgType1(res.data.responseData.value);
			toast.success(`${res.data.message} The newly created Company is now available at the top of the dropdown. Please select it.`);
			setOrganizationName("")
			setOrgCity("")
			setInsName("")
			setFileName("")
			
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message || "An error occurred");
			}
		}
	};

	return (
		<>
			<Modal show={show} onHide={handleClose} centered size="lg" >
				<Modal.Header>
					<Modal.Title>User information</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleClose} />
				</Modal.Header>
				<Modal.Body className="settings">
					{/* {step === 1 && ( */}

					<div className={`content ${activeStep === 1 ? "active" : ""} `}>
						<div className="mb-3">
							<h5 className="fw-bold border-custom d-inline">Basic info</h5>
						</div>
						<div className="profile-setting-form">

							<div className="form-row">
								<div className="post-form-group text-transform-email  email-label-category">
									<label htmlFor="category">
										Email
									</label>
									<input
										type="email"
										id="tag"
										placeholder="Email"
										// onChange={(e) => setEmail(e.target.value)}
										onChange={(e) => handleFieldChange(setEmail, e.target.value)}
										value={email}
										invalid={displays && email === ""}
										className="Normal-Input-Fill"
										disabled
									/>
									{displays && !email ? (
										<span className="error_msg_lbl text-red">Enter Email </span>
									) : null}
								</div>
								<div className="post-form-group">
									<label>
										First name <span className="text-red">*</span>

									</label>
									<input
										type="text"
										placeholder="First Name"
										value={firstName}
										onChange={(e) => setFirstName(e.target.value)}
										id="email"
										name="email"
										className="Normal-Input-Fill"
										invalid={displays && firstName === ""}
									/>
									{displays && !firstName ? (
										<span className="error_msg_lbl text-red">
											Enter first name{" "}
										</span>
									) : null}
								</div>
							</div>
							<div className="form-row">
								<div className="post-form-group">
									<label>
										Last name <span className="text-red">*</span>
									</label>
									<input
										type="text"
										placeholder="Last Name"
										value={lastName}
										onChange={(e) => setLastName(e.target.value)}
										id="email"
										name="email"
										className="Normal-Input-Fill"
										invalid={displays && lastName === ""}
									/>
									{displays && !lastName ? (
										<span className="error_msg_lbl text-red">
											Enter last name{" "}
										</span>
									) : null}
								</div>
								<div className="form-group">
									<label htmlFor="gender">
										Gender <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={genderOptions}
										// onChange={handleGenderSelect}
										onChange={(option) => handleFieldChange(setGenderValue, option ? option.value : "")} // Track changes

										value={
											genderOptions.find(
												(option) => option.value === genderValue
											) || null
										}
										placeholder="Select Gender"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable
									/>
									{displays && !genderValue ? (
										<span className="error_msg_lbl text-red">Enter Gender </span>
									) : null}
								</div>
							</div>
							<div className="form-row">
								<div className="form-group">
									<label htmlFor="city">
										City <span className="text-red">*</span>
									</label>
									<ReactSelect
										options={cityList}
										onInputChange={handleCityInputChange}
										// onChange={handleCitySelect}
										onChange={(option) => handleFieldChange(handleCitySelect, option ? option.value : "")}
										value={cityList?.find((option) => option.value === cityId)} 
										placeholder="Search & Select City"
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										styles={customStyles}
										isClearable={true}
									//onBlur={handleModalClose} 
									/>

									{displays && !cityId ? (
										<span className="error_msg_lbl text-red">Enter City </span>
									) : null}
								</div>
								<div className="form-group">
									<label htmlFor="Langauge">Language</label>

									<ReactSelect
										options={LanguageList}
										// onChange={handleLanguageSelect}
										onChange={(option) => handleFieldChange(setLanguage, option ? option.value : "")} // Track changes
										value={
											LanguageList.find(
												(option) => option.value === language
											) || null
										}
										placeholder="Select Language"
										styles={customStyles}
										classNamePrefix="react-select"
										className="form-control Dark-Input-from-group"
										isClearable
									/>
									{displays && !language ? (
										<span className="error_msg_lbl text-red">Select Language </span>
									) : null}
								</div>

							</div>

							<div className="form-row">


								<div className="form-group">
									<label htmlFor="ProfileImg">Profile Image</label>
									<input
										type="file"
										id="ProfileImg"
										className="form-control Dark-Input-from-group"
										required
										accept="image/jpeg, image/png, image/jpg"
										onChange={(e) => {
											handleFieldChange(setProfileImage, e.target.files[0]);
											setProfileImageview(URL.createObjectURL(e.target.files[0]));
										}}
										style={{ height: '56px', paddingTop: '15px' }}
									/>

									{error && <span className="error_msg_lbl text-red">{error}</span>}
									{!error && !profileImage && (
										<span className="error_msg_lbl text-red">Select an image</span>
									)}
									{profileImageview && (
										<img
											src={profileImageview}
											alt="Profile Preview"
											width={150}
											height={150}
											className="mt-2"
										// style={{ borderRadius: '50%' }}
										/>
									)}
								</div>

								<div className="form-group  Flatpickr-Calender-Class">
									<label htmlFor="dob" className="col-md-12">DOB</label>
									<Flatpickr
										id="dob"
										className="form-control Dark-Input-from-group"
										required
										// onChange={(date) => handleFieldChange(setStartDate, date[0])}
										onChange={(date) => setStartDate(date[0])}
										value={startDate}
										// options={{
										// 	maxDate: new Date(),
										// }}
										invalid={displays && startDate === ""}
										options={{
											maxDate: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
											static: true,
										}}
									/>

									{displays && !startDate ? (
										<span className="error_msg_lbl text-red">Select DOB </span>
									) : null}
								</div>

							</div>

							{/* <div className="text-end">
								<button
									className={`btn btn-primary ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
									onClick={async (e) => {
										if (CandidateId === "Candidate") {
											Profile(e);
										} else {
											InstituteProfile(e);
										}
									}}
									disabled={!formChanged || isSubmitting}
									style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
								>
									Update
								</button>
							</div> */}
							<div className="p-4 col-md-12 text-end mt-4">
								<button
									type="button"
									className="btn btn-primary"
									onClick={(e) => {
										if(moduleName === "Candidate"){
                                          Profile(e);
										} else {
											InstituteProfile(e);
										}
										
									}
									}
								// disabled
								// ={
								// 	email === "" ||
								// 	firstName === "" ||
								// 	lastName === "" ||
								// 	genderValue === null ||
								// 	cityId === null
								// }
								>
									Update
								</button>
							</div>
						</div>
					</div>
					{/* )} */}


					{/* <hr /> */}

					{/* ................................................................................................... */}
					{/*                                             Profile Info                                            */}
					{/* ................................................................................................... */}



				</Modal.Body>
			</Modal>

			<Modal show={showActiveAs} onHide={handleCloseActiveAs} centered size="lg" >
				<Modal.Header>
					<Modal.Title>Current status</Modal.Title>
					<CloseSharpIcon className="pointer" onClick={handleCloseActiveAs} />
				</Modal.Header>
				<Modal.Body className="settings">


					{/* ................................................................................................... */}
					{/*                                             Profile Info                                            */}
					{/* ................................................................................................... */}


					{/* {step === 2 && ( */}
					<div
						className={`content ${activeStep === 2 ? "active" : ""}   `}
					>
						{/* <div className="mb-3">
							<h5 className="fw-bold border-custom d-inline textcolor">Profile Info</h5>
						</div> */}
						<div className="post-job-details-form Edit-Card-details-form">
							<div className="row">
								<div className="col-md-6">
									<div className="post-form-group">
										<label htmlFor="category">Currently active <span className="text-red">
											*
										</span></label>
										<ReactSelect
											options={activeOptions}
											onChange={handleActive}
											value={activeOptions.find((option) => option.value === curretactive) || null}
											placeholder="Select currently active"
											styles={customStyles}
											classNamePrefix="react-select"
											className="form-control"
											isClearable
										/>
										{displays && !curretactive ? (
											<span className="error_msg_lbl text-red">
												Select Currently Active
											</span>
										) : null}
									</div>
								</div>

								{orgType && (<>
									{orgType === "1" || orgType === 1 || orgType === "4" || orgType === 4 ? (
										<>
											<div className="col-md-6">
												<div className="post-form-group">
													<div className="d-flex">
														<label htmlFor="jobApplyType">Institution <span className="text-red">*</span></label>
														<a
															href="#"
															ref={targetRef}
															onClick={(e) => {
																e.preventDefault();
																toggleTooltip();
															}}
															className="createModal ms-2"
														// isDisabled={!selectedIndustryId} // Disable until industry is selected
														>
															Create New
														</a>
														<Overlay
															target={targetRef.current}
															show={showTooltip}
															placement="right"
															rootClose
															container={document.querySelector(".modal")}
															onHide={() => setShowTooltip(false)} // Close when clicking outside
														>
															<Popover id="popover-basic" className="overlay-popover-modal">
																<Popover.Header as="h3" className="Dark-Body-Card-group">Create Institute</Popover.Header>
																<Popover.Body className="Dark-Body-Card-group">
																	<Form>

																		<div className="create-comp-style">
																			<label className="mb-1 Text-mb-Create">Institute name</label>
																			<input
																				type="text"
																				value={OrganizationName}
																				onChange={(e) => {
																					setOrganizationName(e.target.value);
																					setInsName(e.target.value);
																					setInstituteId(e.target.value);
															                        handleFieldChange(setInstituteId, e.target.value, "instituteId")
																					
																				}}
																				placeholder="Enter Institute name"
																				className="mb-2 form-control Dark-Input-from-group"
																			/>
																		</div>

																		<div className="create-comp-style">
																			<label className="mb-1 Text-mb-Create">City</label>
																			<ReactSelect
																				options={cityNameOption}
																				onInputChange={(value) => setSearchTerm(value)} // User input pe search ho
																				onChange={handleCitySelectOrg} // Select hone ke baad clear ho jaye
																				placeholder="Search & Select City"
																				classNamePrefix="react-select"
																				className="form-control Dark-Input-from-group"
																				styles={customStyles}
																				isClearable
																			/>
																		</div>

																		<div className=" mt-2 mb-2 Text-mb-Create">
																			<label className="mb-1">Institute logo</label>
																			<input
																				type="file"
																				id="lastName"
																				className="form-control Dark-Input-from-group"
																				placeholder=""
																				onChange={handleFileChange}
																			//   onChange={(e) => {
																			//     handleProfileImageChange(e);
																			//   }}
																			//   invalid={displays && profileImage === ""}
																			/>
																			{/* {displays && !profileImage ? (
																				<span className="error_msg_lbl text-red">
																					Upload Image{" "}
																				</span>
																			) : null} */}
																		</div>
																		<div className="d-flex justify-content-end">
																			<Button
																				variant="primary"
																				size="sm"
																				onClick={()=>{
																					handleSaveInstitution()
																					setShowTooltip(false)
																				}}
																				className="me-2"
																			>
																				Save
																			</Button>
																			<Button
																				variant="secondary"
																				size="sm"
																				onClick={() => setShowTooltip(false)}
																			>
																				Cancel
																			</Button>
																		</div>
																	</Form>
																</Popover.Body>
															</Popover>
														</Overlay>
													</div>
													{InsName !== "" ? (
														<div>
															<input
																type="text"
																value={InsName}
																placeholder="Enter Org name"
																className="mb-2 form-control Dark-Input-from-group"
																disabled
															/>
														</div>
													) : (
														<ReactSelect
															options={reversedOrgList}
															onChange={(selectedOption) => handleFieldChange(handleInstitute, selectedOption)}
															// value={
															// 	getallorgsList.find(
															// 		(option) => option.value === instituteId
															// 	) || null
															// }
															value={
																reversedOrgList.find(
																	(option) => {
																		if (InsName !== "" && InsName !== null) {
																			return option.value === InsName;
																		} else {
																			return option.value === instituteId && option.tagId === orgType;
																		}
																	}
																) || null
															}
															getOptionValue={(option) => `${option.value}-${option.tagId}`}
															formatOptionLabel={(option) => (
																<div style={{ fontWeight: option.tagId === 1? "bold" : "normal" }}>
																	{option.label}
																</div>
															)}
															placeholder="Select Institute Type"
															styles={customStyles}
															classNamePrefix="react-select"
															className="form-control"
															// onInputChange={(inputValue) =>
															// 	setInstituteSearch(inputValue)
															// }
															isClearable
															invalid={displays && instituteSearch === ""}
														/>
													)}
													{displays && !instituteId ? (
														<span className="error_msg_lbl text-red">
															Select Institution
														</span>
													) : null}

												</div>
											</div>
											<div className="col-md-6 mt-2">
												<div className="post-form-group">
													<label htmlFor="minSalary">HeadLine</label>
													<input
														type="text"
														id="minSalary"
														placeholder="HeadLine"
														required
														onChange={(e) => setHeadLine(e.target.value)}
														value={headLine}
														invalid={displays && headLine === ""}
														className="Normal-Input-Fill"
													/>
													{/* {displays && !headLine ? (
													<span className="error_msg_lbl text-red">
														Enter HeadLine
													</span>
												) : null} */}
												</div>
											</div>
											<div className="col-md-6 mt-2">
												<div className="post-form-group text-transform-email">
													<label htmlFor="experience">Website</label>
													<input
														type="text"
														id="experience"
														placeholder="Website"
														onChange={(e) => setWebsite(e.target.value)}
														value={website}
														invalid={displays && website === ""}
													/>
													{/* {displays && !website ? (
													<span className="error_msg_lbl text-red">
														Enter Website
													</span>
												) : null} */}
												</div>
											</div>
											<div className="post-form-row">
												<div className="post-form-group mt-2">
													<label htmlFor="maxSalary">About</label>
													<textarea
														type="text"
														id="maxSalary"
														placeholder="About"
														onChange={(e) => setAbout(e.target.value)}
														value={about}
														invalid={displays && about === ""}
														className="normalinput-fill-border"
													/>
													{/* {displays && !about ? (
													<span className="error_msg_lbl text-red">
														Enter About
													</span>
												) : null} */}
												</div>
											</div>
										</>
									) : (
										<>

											<div className="post-form-group">
												<div className="d-flex">
													<label htmlFor="gender">Company <span className="text-red">*</span></label>
													<a
														href="#"
														ref={targetRef}
														onClick={(e) => {
															e.preventDefault();
															toggleTooltip();
														}}
														className="createModal ms-1"

													// isDisabled={!selectedIndustryId} // Disable until industry is selected
													>
														Create New
													</a>
												</div>
												<Overlay
													target={targetRef.current}
													show={showTooltip}
													placement="right"
													rootClose
													container={document.querySelector(".modal")}
													onHide={() => setShowTooltip(false)} // Close when clicking outside
												>
													<Popover id="popover-basic" className="overlay-popover-modal">
														<Popover.Header as="h3" className="Dark-Body-Card-group">Create Company</Popover.Header>
														<Popover.Body className="Dark-Body-Card-group">
															<Form>
																<div>
																	<label className="mb-1 Text-mb-Create">Company name</label>
																	<input
																		type="text"
																		value={OrganizationName}
																		onChange={(e) => {
																			setOrganizationName(e.target.value);
																			setInsName(e.target.value);
																			setCompanyId(e.target.value)
																			handleFieldChange(setCompanyId,e.target.value,"companyId")
																		}}
																		placeholder="Enter Company name"
																		className="mb-2 form-control Dark-Input-from-group"
																	/>
																</div>
																<div>
																	<label className="mb-1 Text-mb-Create">City</label>
																	<ReactSelect
																		options={cityNameOption}
																		onInputChange={(value) => setSearchTerm(value)}
																		onChange={handleCitySelectOrg}
																		placeholder="Search & Select City"
																		classNamePrefix="react-select"
																		className="form-control Dark-Input-from-group"
																		styles={customStyles}
																		isClearable
																	/>
																</div>
																<div className=" mt-2 mb-2 Text-mb-Create">
																	<label className="mb-1">Company Logo</label>
																	<input
																		type="file"
																		id="lastName"
																		className="form-control Dark-Input-from-group"
																		placeholder=""
																		onChange={handleFileChange}
																	//   onChange={(e) => {
																	//     handleProfileImageChange(e);
																	//   }}
																	//   invalid={displays && profileImage === ""}
																	/>
																	{/* {displays && !profileImage ? (
																			<span className="error_msg_lbl text-red">
																				Upload Image{" "}
																			</span>
																		) : null} */}
																</div>
																<div className="d-flex justify-content-end">
																	<Button
																		variant="primary"
																		size="sm"
																		onClick={()=>{
																			handleSaveInstitution1()
																			setShowTooltip(false);
																		}}
																		className="me-2"
																	>
																		Save
																	</Button>
																	<Button
																		variant="secondary"
																		size="sm"
																		onClick={() => setShowTooltip(false)}
																	>
																		Cancel
																	</Button>
																</div>
															</Form>
														</Popover.Body>
													</Popover>
												</Overlay>
												{InsName !== "" ? (
													<div>
														<input
															type="text"
															value={InsName}
															placeholder="Enter Org name"
															className="mb-2 form-control Normal-Input-Fill"
															disabled
														/>
													</div>
												) : (
													<ReactSelect
														options={reversedCompList}
														onChange={handleCompany}
														// value={
														// 	getcompaniesList.find(
														// 		(option) => option.value === companyId
														// 	) || null
														// }
														value={
															reversedCompList.find(
																(option) => {
																	if (InsName !== "" && InsName !== null) {
																		return option.value === InsName;
																	} else {
																		return option.value === companyId && option.tagId === orgType;
																	}
																}
															) || null
														}
														getOptionValue={(option) => `${option.value}-${option.tagId}`}
														formatOptionLabel={(option) => (
															<div style={{ fontWeight: option.tagId === 2 ? "bold" : "normal" }}>
																{option.label}
															</div>
														)}
														placeholder="Select Company"
														styles={customStyles}
														classNamePrefix="react-select"
														className="form-control"
														// onInputChange={(inputValue) =>
														// 	setCompanySearch(inputValue)
														// }
														isClearable
														invalid={displays && companySearch === ""}
													/>
												)}
												{displays && (!companyId && !getOrgInsTId1) ? (
													<span className="error_msg_lbl text-red">
														Select Company
													</span>
												) : null}

											</div>



											<div className="post-form-group mt-2">
												<label htmlFor="externalUrl">Designation <span className="text-red">*</span></label>
												<ReactSelect
													options={designationList}
													onChange={handleDesignation}
													value={
														designationList.find(
															(option) => option.label === designationId
														) || null
													}
													placeholder="Select Designation Type"
													styles={customStyles}
													classNamePrefix="react-select"
													className="form-control"
													onInputChange={(inputValue) =>
														setDesignationSearch(inputValue)
													}
													isClearable
													invalid={displays && designationSearch === ""}
												/>
												{displays && !designationId ? (
													<span className="error_msg_lbl text-red">
														Select Designation
													</span>
												) : null}
											</div>
											<div className="post-form-group mt-2">
												<label htmlFor="minSalary">HeadLine</label>
												<input
													type="text"
													id="minSalary"
													placeholder="HeadLine"
													required
													onChange={(e) => setHeadLine(e.target.value)}
													value={headLine}
													invalid={displays && headLine === ""}
													className="Normal-Input-Fill"
												/>
											</div>
											<div className="col-md-12">
												<div className="post-form-group text-transform-email">
													<label htmlFor="experience">Website</label>
													<input
														type="text"
														id="experience"
														placeholder="Website"
														onChange={(e) => setWebsite(e.target.value)}
														value={website}
														invalid={displays && website === ""}
													/>

												</div>
											</div>
											<div className="col-md-12">
												<div className="post-form-group">
													<label htmlFor="maxSalary">About</label>
													<textarea
														type="text"
														id="maxSalary"
														placeholder="About"
														onChange={(e) => setAbout(e.target.value)}
														value={about}
														invalid={displays && about === ""}
														className="normalinput-fill-border"
													/>
												</div>
											</div>



										</>
									)}
								</>
								)}

							</div>
							<div className="text-end mt-4 d-flex justify-content-end">
								{/* <div className="previousBtnCont d-flex align-items-center">
									<button
										type="button"
										className="btn btn-primary"
										onClick={() => setStep(1)}
									>
										Previous
									</button>
								</div> */}
								<button
									type="button"
									className="btn btn-primary"
									onClick={handleSaveClickNew}
								>
									Update
								</button>
							</div>
						</div>
					</div>
					{/* )} */}

				</Modal.Body>
			</Modal>
		</>




	);
};

export default UpdateResume;
